export default __webpack_public_path__ + "static/media/uk.08605bdb.png";